import React, { useState } from 'react';
import { AccordionItem } from './AccordionItem';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="defer-paint w-full bg-white pb-10 sm:pb-20" aria-labelledby="faq-heading" data-id="element-74" data-mp="1blai55q0olsb">
      <div className="mx-auto max-w-2xl px-5 sm:px-6" data-id="element-75" data-mp="1gitvm3ew4uj7">
        <h2 id="faq-heading" className="flex items-center justify-center gap-3 text-center font-display text-2xl font-bold text-navy sm:text-4xl" data-id="element-76" data-mp="1glpwo0m1bzbv">
          <div className="h-7 w-7 text-gold-text" strokeWidth={2} aria-hidden="true" data-id="element-77" data-mp="28b1d16280ayn" />
          Frequently Asked Questions
        </h2>

        <ul className="mt-6 space-y-2.5 sm:mt-10" data-id="element-78" data-mp="1uj4ofbzrgj70">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <AccordionItem key={faq.question} id={`faq-${index}`} isOpen={isOpen} onToggle={() => setOpenIndex(isOpen ? null : index)} header={<span className="block text-sm font-bold leading-snug text-navy sm:text-base" data-id="element-80" data-mp="2rzk6w0y68cjo">
                    {faq.question}
                  </span>} data-id="element-79" data-mp="2n8btkttq0718" data-mpi={index}>
                <div className="text-sm leading-relaxed text-body" data-id="element-81" data-mp="10toy6a8acer4">
                  <p data-id="element-82" data-mp="10vjknsz7gexb">{faq.answer}</p>
                  {faq.list ? <ul className="mt-2 space-y-1" data-id="element-83" data-mp="1eln0o27hrceb">
                      {faq.list.map(item => <li key={item} className="flex items-start gap-2" data-id="element-84" data-mp="19udhnkgg77be">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold-text" aria-hidden="true" data-id="element-85" data-mp="19sagc49uhrrd" />
                          {item}
                        </li>)}
                    </ul> : null}
                  {faq.outro ? <p className="mt-2" data-id="element-86" data-mp="1xjzcxwtp92e4">{faq.outro}</p> : null}
                </div>
              </AccordionItem>;
        })}
        </ul>
      </div>
    </section>;
}